<template>
  <form-group :validator="v" :label="$t('FullAddress')">
    <input
      type="text"
      class="input"
      v-model="addressName"
      :placeholder="$t('housenumber')"
      @input="v.$touch()"
    />
  </form-group>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    v: {
      type: Object,
      required: true
    }
  },
  computed: {
    addressName: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
